var dynamicBoxId = null;
var sellingPlans = null;
const boxParentProductId = window.dynamicBoxID || 7418264584255;
var sellingPlanID = null;
var sellingPlan = null;
var infoIcon = '<span class="gm-sub-popup-trig gm-info-trig"><svg xmlns="http://www.w3.org/2000/svg" height="15.171" width="15.171"><path stroke-width=".5" stroke="currentColor" fill="currentColor" d="M7.585.25a7.335 7.335 0 1 0 7.335 7.335A7.331 7.331 0 0 0 7.585.25Zm0 13.525a6.189 6.189 0 1 1 6.189-6.189 6.186 6.186 0 0 1-6.189 6.189Z"></path><path stroke-width=".5" stroke="currentColor" fill="currentColor" d="M7.585 7.052a.538.538 0 0 0-.573.495v3.186a.579.579 0 0 0 1.146 0V7.547a.538.538 0 0 0-.573-.495Z"></path><circle stroke-width=".5" stroke="currentColor" fill="currentColor" r=".774" cy=".774" cx=".774" transform="translate(6.812 4.142)"></circle></svg></span>';
console.log(boxParentProductId);
const fetchDynamicBoxInformation = async(boxParentProductId) => {
  return new Promise((resolve, reject) => {
    fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
      method: 'POST',
      body: JSON.stringify({
        'productPlatformId': boxParentProductId,
      })
    })
    .then((response) => response.json())
    .then((response) => {
      if(!response.ok) throw new Error('Failed to get box');
      const { DynamicBox } = response;
      resolve(DynamicBox);
      // console.log(response);
    })
    .catch((error) => {
      console.error(error);
      reject(error);
    })
  });
}

$('.bab__wrapper').hide();

fetchDynamicBoxInformation(boxParentProductId)
.then((dynamicBox) => {
  
  console.log('Dynamic Box Information:', dynamicBox);

  
  $('.bab__wrapper').show();
  $('.bab__wrapper').addClass(dynamicBox.boxId);
  
  dynamicBoxId = dynamicBox.boxId;
  sellingPlans = dynamicBox.sellingPlanGroup;
  sellingPlanID = getMonthlySellingPlanID(sellingPlans);
  sellingPlan = getMonthlySellingPlan(sellingPlans);
  //BAB_displayFrequencies(sellingPlans)

  BAB_showProgressBar(dynamicBox.percentDiscountTier);
  BAB_stickyShowProgressBar(dynamicBox.percentDiscountTier);
  BAB_displayProducts(dynamicBox.selectableProductVariants);
  // BAB_reorderProducts();

  BAB_loadProgressBarFromCart();
  BAB_LoadQuantityFromCart();
  BAB_attachQuickView();


  BAB_changeSubProductTitle('essentials-nutrition-bar-brownie', 'Fudgy Brownie');


  BAB_addBestSellerBadge('essentials-nutrition-shake');
  // BAB_addTextToProductTitle('calm', 'Mood Support');
  // BAB_addTextToProductTitle('vitality', 'Energy Boost');
  // BAB_addTextToProductTitle('balance', 'Stress Support');
  // BAB_addTextToProductTitle('clarity', 'Mental Boost');
  BAB_replaceProductTitleText('adaptogen-stress-support-supplement', 'Adaptogen Supplement');
  BAB_replaceProductTitleText('adaptogen-mood-support-supplement', 'Adaptogen Supplement');
  BAB_replaceProductTitleText('adaptogen-brain-support-supplement', 'Adaptogen Supplement');
  BAB_replaceProductTitleText('adaptogen-energy-support-supplement', 'Adaptogen Supplement');
  
  BAB_updateBarsText();
  BAB_updateSellingPlan();
  BAB_UpdateBarDiscount();
})
.catch((error) => {
  console.error('Error fetching dynamic box information:', error);
});

function capitalizeWords(string) {
   return string.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
};

function BAB_showProgressBar(discountData){

  const $wrapper = $('.bab__wrapper .bab__progress-bar-wrapper');
  
  // Loop through the quantities, starting at 1 and ending at 3
  for (let qty = 1; qty <= 3; qty++) {
    // Check if there's a discount for the current quantity, defaulting to "0" if missing
    const discount = discountData[qty] || "0";
  
    // Create the progress bar item and set the data attributes
    const $progressBarItem = $(`
        <div class="bab__progress-bar-item" data-qty="${qty}" data-off="${discount}">
            <div class="bab__progress-bar-head">${qty} ${qty === 1 ? "Product" : "Products"}</div>
            <div class="bab__progress-bar-counter">${qty}</div>
            <div class="bab__progress-bar-off">${discount !== "0" ? discount + "% off" : ""}</div>
        </div>
    `);
  
    // Append the new item to the wrapper
    $wrapper.append($progressBarItem);
  }
}

function BAB_stickyShowProgressBar(discountData){
  const $wrapper = $('.bab__sticky-checkout-progress .bab__progress-bar-wrapper');
  
  for (let qty = 1; qty <= 3; qty++) {
      // Check if there's a discount for the current quantity, defaulting to "0" if missing
      const discount = discountData[qty] || "0";
  
      // Create the progress bar item with specified structure
      const $progressBarItem = $(`
          <div class="bab__progress-bar-item" data-qty="${qty}" data-off="${discount}">
              <div class="bab__progress-bar-counter">${qty}</div>
              <div class="bab__progress-bar-off">
                  ${qty}${qty === 1 ? " Product" : (qty === 3 ? "+ Products" : " Products")}
                  <span>${discount !== "0" ? discount + "% off" : ""}</span>
              </div>
          </div>
      `);
  
      // Append the new item to the wrapper
      $wrapper.append($progressBarItem);
  }
}
function BAB_updateSellingPlan(){
  $('input[name=box_selling_plan]').val( sellingPlanID );
  $('#subscription-toggle').attr('checked',true).trigger('change');
  // $('.gm-discount').text(sellingPlan.priceAdjustmentAmount);
}

function getMonthlySellingPlan(sellingPlans){
  for (const [key, value] of Object.entries(sellingPlans)) {
    if(value.interval.toLowerCase() == "month"){
      return value;
    }
  }
}
function getMonthlySellingPlanID(sellingPlans){
  for (const [key, value] of Object.entries(sellingPlans)) {
    let id = key.replace('gid://shopify/SellingPlan/','');

    if(value.interval.toLowerCase() == "month"){
      return id;
    }
    
  }
}

function BAB_updateBarsText(){
  // Using regular expression to extract text between parentheses


  $('.product__item[data-handle="essentials-nutrition-bar-brownie"], .product__item[data-handle="essentials-nutrition-bar-lemon"]').each(function(){

    let inputString = $(this).find('.product__item-title').text();
    let mainTitle = $(this).find('.main__title');
    let subTitle = $(this).find('.sub__title');

    var matchResult = inputString.match(/\(([^)]+)\)/);
    
    // Extracted text is in matchResult[1]
    if (matchResult) {
        var textInsideParentheses = matchResult[1];

        mainTitle.text(mainTitle.text().replace(matchResult[0],''));
        subTitle.text(textInsideParentheses);
    } else {
        console.log("No text found between parentheses.");
    };
  })
  
  
}
// Display intervals/frequencies
function BAB_displayFrequencies(sellingPlans){

  let optionsHTML = `<select name="box_selling_plan"><option value="" selected>One-Time Purchase</option>`;

  for (const [key, value] of Object.entries(sellingPlans)) {
    let id = key.replace('gid://shopify/SellingPlan/','');
    
    let title = value.title.replace('every','');
    
    if(value.interval.toLowerCase() == "month"){
      title = "Monthly Subscription";
    }

    optionsHTML += `<option value="${id}" data-interval="${value.interval.toLowerCase()}" selected>${title}</option>`;
    
  }
  optionsHTML += `</select>`;
  $('.bab__frequencies .bab__select').append(optionsHTML);

  //Sort
  // $('select[name=box_selling_plan]').find('option').sort(function (a, b) {
  //  return $(a).attr('data-interval') - $(b).attr('data-interval');
  // }).appendTo('select[name=box_selling_plan]');
  
  $('.bab__frequencies select').val($('.bab__frequencies select option:first-child').val()).change();

}
// Reorder products
function BAB_reorderProducts(){
  
  $('.product__item[data-handle="vitality"]').attr('data-order',"4");
  $('.product__item[data-handle="clarity"]').attr('data-order',"5");
  $('.product__item[data-handle="balance"]').attr('data-order',"6");
  $('.product__item[data-handle="calm"]').attr('data-order',"7");

  //Sort
  $('.products__wrapper').find('.product__item').sort(function (a, b) {
   return $(a).attr('data-order') - $(b).attr('data-order');
  }).appendTo('.products__wrapper');
  
}

function BAB_attachQuickView(){
  
  bab_quickviews.forEach((item, i)=>{
    let quickViewHTML = '';
     if(bab_quickviews[i].imgURL && bab_quickviews[i].text && bab_quickviews[i].keyText){
      quickViewHTML = ` <div class="product__quickview">
                          <div class="product__quickview-wrapper">
                            <div class="product__quickview-close">
                              <span>×</span>
                            </div>
                              <img src="${bab_quickviews[i].imgURL}">
                              <p>${bab_quickviews[i].text}</p>
                              <div class="product__quickview_key-text">
                                ${bab_quickviews[i].keyText}
                              </div>
                          </div>
                        </div>`;
    }
    $(`.product__item[data-gid="gid://shopify/ProductVariant/${bab_quickviews[i].handle}"]`).append(quickViewHTML);
  });

}

//Add text to products
function BAB_addTextToProductTitle(handle, text){
  let oldText = $('.product__item[data-handle="'+handle+'"]').find('.product__item-title').text();
  $('.product__item[data-handle="'+handle+'"]').find('.product__item-title').html(`<span class="main__title">${oldText}</span> `+`<span class="sub__title">${text}</span>`);
}

//Replace product title text
function BAB_replaceProductTitleText(handle, text){
  $('.product__item[data-handle="'+handle+'"]').find('.product__item-title .main__title').text(`${text}`);
}

//Change subtitle
function BAB_changeSubProductTitle(handle, text){
  let oldText = $('.product__item[data-handle="'+handle+'"]').find('.sub__title').text(`${text}`);
}

//Add Badge Best Seller
function BAB_addBestSellerBadge(handle){
  let oldText = $('.product__item[data-handle="'+handle+'"]').find('.product__image').prepend('<span class="product__badge">Best Seller</span>');
}

// Display products
function BAB_displayProducts(products){
  let productsHTML = `<div class="products__wrapper">`;
  let i = 0;
  products.forEach((item, index)=>{
  	console.log(index, item);
    item.productVariants.forEach((item1,index1)=>{
      let pImage = item.productImageSrc;
      let pTitle = item.productTitle;
      let quickViewHTML = ``;
      
      if(item1.productVariantTitle.includes("Default")){
        pTitle = item.productTitle;
      }
      else{
        pTitle = `<span class="main__title">${item.productTitle}</span>`+ ' ' + `<span class="sub__title">${item1.productVariantTitle}</span>`;
      }

      pTitle = capitalizeWords(pTitle.toLowerCase());
      
      if(item1.imageSrc){
        pImage = item1.imageSrc;
      }

      let factsText = "View Nutrition Facts";

      if(item.productHandle == "vitality" || item.productHandle == "calm" || item.productHandle == "balance" || item.productHandle == "clarity"  ){
       factsText = "View Supplement Facts";
      }
      
      let productItemHTML = `<div class="product__item" data-handle="${item.productHandle}" data-gid="${item1.platformId}" data-price="${item1.price}" data-order="${i}">
                              <div class="product__item-title">${pTitle}</div>
                              <div class="product__image"><div class="product__item-price">${bab_currency_symbol}${item1.price}</div><img src="${pImage}"></div>
                              <a class="product__nutri-facts sadasd" id="handle-${i}"><img src="https://cdn.shopify.com/s/files/1/2001/9829/files/page-icon.svg?v=1662437696">${factsText}</a>
                              <div class="product__quantity-group"> 
                                <button class="minus">-</button> 
                                <input type="number" name="quantity" class="" value="0" min="0" readonly></input>
                                <button class="plus">+</button>
                              </div> 
                            
                             </div>`;
      productsHTML += productItemHTML;
      i++;
    });
  });
  productsHTML += `</div>`
  $('.bab__products').html(productsHTML);
}

// Update progress bar
function BAB_UpdateProgressBar(){
  let qty = 0;
  let lastItem = $('.bab__progress-bar-item').last();
  let lastQty = parseInt(lastItem.attr('data-qty'));
  let progressItems = $('.bab__wrapper .bab__progress-bar-item');
  let progressItems2 = $('.bab__sticky-checkout-progress .bab__progress-bar-item');
  let productInputQuantities = $('.product__quantity-group input[name=quantity]');
  
  productInputQuantities.each(function(){
    qty += parseInt($(this).val());
  })

  progressItems.removeClass('completed');
  progressItems.removeClass('active');
  progressItems.each(function(index, item){
    $thisQty = parseInt($(this).attr('data-qty'));
    if($thisQty == qty){
        $(this).addClass('active');
        for(let i = 0; i < index; i++){
          progressItems.eq(i).addClass('completed');
        }
    }
    else if(qty > lastQty ){
      progressItems.addClass('completed');
      lastItem.addClass('active');
    }
  });

  // 
  progressItems2.removeClass('completed');
  progressItems2.removeClass('active');
  progressItems2.each(function(index, item){
    $thisQty = parseInt($(this).attr('data-qty'));
    if($thisQty == qty){
        $(this).addClass('active');
        for(let i = 0; i < index; i++){
          progressItems2.eq(i).addClass('completed');
        }
    }
    else if(qty > lastQty ){
      progressItems2.addClass('completed');
      lastItem.addClass('active');
    }
  });
}

// Update individual cart item when quantity changes
function BAB_UpdateCartItem(productElement, newQty, previousQty){
  const id = productElement.attr('data-gid').replace('gid://shopify/ProductVariant/','');
  const selling_plan = $("input[name=box_selling_plan]").val();
  
  if(newQty === 0 && previousQty > 0){
    // Remove all items from cart
    BAB_RemoveFromCart(id, productElement);
  } else if(newQty > previousQty){
    // Add only 1 item (the difference)
    const itemData = {
      quantity: 1,
      id: id,
      selling_plan: selling_plan,
      properties: {
        _dynamicBoxIndex: 0,
        _dynamicBoxId: dynamicBoxId
      }
    };
    
    BAB_AddToCart(itemData, productElement);
  } else if(newQty < previousQty && newQty > 0){
    // Remove 1 item (decrease by 1)
    BAB_ChangeCartQuantity(id, newQty, productElement);
  }
}

// Add item to cart
function BAB_AddToCart(itemData, productElement = null){
  var _cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  const formData = {
    items: [itemData],
    sections: _cart.getSectionsToRender().map((section) => section.id),
    sections_url: window.location.pathname
  };
  
  // Show loading state
  if(productElement) {
    BAB_SetLoadingState(productElement, true);
  }
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(function (response) {
    console.log('Item added to cart:', response);
    response.items.forEach(item => {
      item['sections'] = response.sections;
      _cart.renderContents(item);
    });
  })
  .catch((error) => {
    console.error('Error adding to cart:', error);
  })
  .finally(() => {
    // Hide loading state
    if(productElement) {
      BAB_SetLoadingState(productElement, false);
    }

 
    if (_cart && _cart.classList.contains('is-empty')) _cart.classList.remove('is-empty');
  });
}

// Remove item from cart
function BAB_RemoveFromCart(variantId, productElement = null){
  let _cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  // Show loading state
  if(productElement) {
    BAB_SetLoadingState(productElement, true);
  }
  
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 0,
      sections: _cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    })
  })
  .then(response => response.json())
  .then(function (response) {
    console.log('Item removed from cart:', response);

    if(response.item_count == 0){
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: {}, sections: ["cart-drawer", "cart-icon-bubble"] }),
      })
      .then((res) => res.json())
      .then((cart) => {
        document.querySelector("cart-drawer").renderContents(cart);
        document.querySelector("cart-drawer.drawer").classList.add("is-empty");
      });
    }
    else{
      response.items.forEach(item => {
        item['sections'] = response.sections;
        _cart.renderContents(item);
      });
    }

  })
  .catch((error) => {
    console.error('Error removing from cart:', error);
  })
  .finally(() => {
    // Hide loading state
    if(productElement) {
      BAB_SetLoadingState(productElement, false);
    }
    console.log('removing from cart');
    if (_cart && _cart.classList.contains('is-empty')) _cart.classList.remove('is-empty');
  });
}

// Change cart item quantity to specific amount
function BAB_ChangeCartQuantity(variantId, quantity, productElement = null){
  // Show loading state
  let _cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');


  if(productElement) {
    BAB_SetLoadingState(productElement, true);
  }
  
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity,
      sections: _cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    })
  })
  .then(response => response.json())
  .then(function (response) {
    console.log('Cart quantity updated:', response);
    response.items.forEach(item => {
      item['sections'] = response.sections;
      _cart.renderContents(item);
    });
  })
  .catch((error) => {
    console.error('Error updating cart quantity:', error);
  })
  .finally(() => {
    // Hide loading state
    if(productElement) {
      BAB_SetLoadingState(productElement, false);
    }

    if (_cart && _cart.classList.contains('is-empty')) _cart.classList.remove('is-empty');
  });
}

// Set loading state for product elements
function BAB_SetLoadingState(productElement, isLoading){
  const quantityGroup = productElement.find('.product__quantity-group');
  const buttons = quantityGroup.find('button');
  const input = quantityGroup.find('input');
  
  if(isLoading){
    buttons.attr('disabled', true);
    input.attr('disabled', true);
    productElement.addClass('bab-loading');
    
    // Add loading spinner to quantity group
    if(!quantityGroup.find('.bab-spinner').length){
      quantityGroup.append('<div class="bab-spinner"></div>');
    }
  } else {
    buttons.attr('disabled', false);
    input.attr('disabled', false);
    productElement.removeClass('bab-loading');
    
    // Remove loading spinner
    quantityGroup.find('.bab-spinner').remove();
  }
}

// Set loading state for sticky checkout items
function BAB_SetStickyLoadingState(stickyElement, isLoading){
  const quantityGroup = stickyElement.find('.bab__sticky-product-quantity-group');
  const buttons = quantityGroup.find('button');
  const input = quantityGroup.find('input');
  
  if(isLoading){
    buttons.attr('disabled', true);
    input.attr('disabled', true);
    stickyElement.addClass('bab-loading');
    
    // Add loading spinner to quantity group
    if(!quantityGroup.find('.bab-spinner').length){
      quantityGroup.append('<div class="bab-spinner"></div>');
    }
  } else {
    buttons.attr('disabled', false);
    input.attr('disabled', false);
    stickyElement.removeClass('bab-loading');
    
    // Remove loading spinner
    quantityGroup.find('.bab-spinner').remove();
  }
}

function BAB_UpdateStickyItems(){
  let TotalQty = BAB_GetTotalQuantity();
  let noProductView = $('.bab__sticky-checkout.no__product-view');
  let productView = $('.bab__sticky-checkout.product__view');
  let checkoutItems = $('.bab__sticky-checkout-items');
  let productsSelected = $('.product__item.selected');
  console.log('TotalQty: '+TotalQty);

  // if(TotalQty>0){
  //   productView.removeClass('hidden');
  //   noProductView.addClass('hidden');
  // }
  // else{
  //   noProductView.removeClass('hidden');
  //   productView.addClass('hidden');
  // }

 let sticyItemHTML = '';
  
 let totalPrice = 0;
  
  productsSelected.each(function(){
    let title = $(this).find('.product__item-title').text();
    let imgSrc = $(this).find('img').attr('src');
    let inputQty = $(this).find('input[name="quantity"]').val();
    let gid = $(this).attr('data-gid');
    let price = $(this).attr('data-price');
    
    totalPrice += parseInt(price);
    
    sticyItemHTML += `<div class="bab__sticky-checkout-item " title="${title}" data-gid="${gid}">
                        <div class="bab__sticky-product-image"><img src="${imgSrc}"></div>
                        <div class="bab__sticky-product-right">
                          <div class="bab__sticky-product-title" title="${title}">${title}</div>
                          <div class="bab__sticky-product-quantity-group">
                            <button class="minus">-</button>
                            <input type="number" name="quantity" class="" value="${inputQty}" min="0" readonly aria-label="quantity">
                            <button class="plus">+</button>
                          </div>
                        </div>
                    </div>`;
  });
  checkoutItems.html(sticyItemHTML);

}
function BAB_UpdateSavePrice(){
  let productsSelected = $('.product__item.selected');
  let totalPrice = 0;
  
  productsSelected.each(function(){
    let price = parseInt($(this).attr('data-price'));
    let qty = parseInt($(this).find('input[name="quantity"]').val());
    price = price * qty;
    totalPrice += parseInt(price);
  });
  
  let off = parseInt($('.bab__progress-bar-item.active').attr('data-off'));
  let savedPrice = totalPrice - (totalPrice * ( off / 100 )) || 0;
  let diff = totalPrice - savedPrice;

  if(diff>0){
    $('.bab__save-price').show();
    $('.bab__sticky-checkout-lefttext').addClass('medium-hidden');
    $('.bab__sticky-checkout-button').addClass('medium-full-w');
  }
  else{
    $('.bab__save-price').hide();
    $('.bab__sticky-checkout-lefttext').removeClass('medium-hidden');
    $('.bab__sticky-checkout-button').removeClass('medium-full-w');
  }
  
  $('.bab__price-saved').text(bab_currency_symbol + parseFloat(savedPrice).toFixed(2));
  $('.bab__price-og').text(bab_currency_symbol + parseFloat(totalPrice).toFixed(2));
  $('.bab__price-diff').text(bab_currency_symbol + parseFloat(diff).toFixed(2));

  if($('.toggle-switch-check').is(':checked')){
    const subscriptionPercentage = sellingPlan.priceAdjustmentAmount / 100;
    const subscriptionPriceOffCombined = savedPrice * subscriptionPercentage;
    const subscriptionPriceCombined = savedPrice - subscriptionPriceOffCombined || 0;
    const subscriptionPriceCombinedDiff = totalPrice - subscriptionPriceCombined;
    const subscriptionPriceCombinedDiscount = off + sellingPlan.priceAdjustmentAmount || 0;
    const subscriptionPriceConsecutiveDiscount = (subscriptionPriceCombinedDiff / totalPrice) * 100 || 0;
    
    const subscriptionPriceOff = totalPrice * subscriptionPercentage; 
    const subscriptionPrice = totalPrice - subscriptionPriceOff || 0;

    const subscriptionPriceText = bab_currency_symbol + parseFloat(subscriptionPrice).toFixed(2);
    const firstOrderPriceText = bab_currency_symbol + parseFloat(subscriptionPriceCombined).toFixed(2) + ' for the 1st month<br>';

    savedPrice = subscriptionPriceCombined;
    
    $('.toggle-switch-handle').html(firstOrderPriceText);
    $('.bab__price-saved').text(bab_currency_symbol + subscriptionPriceCombined.toFixed(2));
    $('.bab__price-diff').text(bab_currency_symbol + subscriptionPriceCombinedDiff.toFixed(2));
    $('.gm-discount').text(Math.round(subscriptionPriceCombinedDiscount));
    $('.handle-txt').html(`Monthly Auto-Ship of ${subscriptionPriceText} / month &nbsp;` + infoIcon);
  }
  else{
    if(totalPrice>savedPrice){
       $('.toggle-switch-handle').html(`<span>${bab_currency_symbol}${totalPrice.toFixed(2)}</span> `+bab_currency_symbol + parseFloat(savedPrice).toFixed(2));
    }
    else{
       $('.toggle-switch-handle').text(bab_currency_symbol + parseFloat(savedPrice).toFixed(2));
    }
      
  }

  const babFG = $(".bab__fg");
  if(babFG.length && savedPrice >= 100) {
    babFG.addClass('unlocked');
  }
  else{
    babFG.removeClass('unlocked');
  }
}

function BAB_GetTotalQuantity(){
  let productInputQuantities = $('.product__quantity-group input[name=quantity]');
  let qty = 0;
  productInputQuantities.each(function(){
    qty += parseInt($(this).val());
  });

  return qty;
}
function BAB_UpdateBarDiscount(){
  let progressItems = $('.bab__wrapper .bab__progress-bar-item');
  let progressItems2 = $('.bab__sticky-checkout-progress .bab__progress-bar-item');

  progressItems2.each(function(index, item){
    $thisOff = parseInt($(this).attr('data-off'));
    totalOff = sellingPlan.priceAdjustmentAmount + $thisOff;
    elOff = $(this).find('.bab__progress-bar-off span');
    
    if($('.toggle-switch-check').is(':checked')){
     if(totalOff>0){
       $(elOff.text(`${totalOff}% off`));
     }
     else{
       elOff.text('');
     }
    }
    else{
     if($thisOff>0){
       $(elOff.text(`${$thisOff}% off`));
     }
     else{
       elOff.text('');
     }
    }
    
  });
  
  progressItems.each(function(index, item){
    $thisOff = parseInt($(this).attr('data-off'));
    totalOff = sellingPlan.priceAdjustmentAmount + $thisOff;
    elOff = $(this).find('.bab__progress-bar-off');
    
    if($('.toggle-switch-check').is(':checked')){
     if(totalOff>0){
       $(elOff.text(`${totalOff}% off`));
     }
     else{
       elOff.text('');
     }
    }
    else{
     if($thisOff>0){
       $(elOff.text(`${$thisOff}% off`));
     }
     else{
       elOff.text('');
     }
    }
  });
  
}
$(document).on('click','.product__quantity-group',function(e){
  const $this = $(this);
  let qtEL = $this.find('input[name=quantity]');
  let qty = parseInt($this.find('input[name=quantity]').val());
  let previousQty = qty;
  
  if(e.target.classList.contains('plus')){
       qty += 1;
       qtEL.val(qty);
  }
  if(e.target.classList.contains('minus')){
      if(qty>0){
       qty -= 1;
       qtEL.val(qty);
      }
  }
  
  if(qty>0){
    $this.parent().addClass('selected');
  }
  else{
    $this.parent().removeClass('selected');
  }

  // Update cart immediately when quantity changes
  if(qty !== previousQty){
    BAB_UpdateCartItem($this.parent(), qty, previousQty);
  }

  BAB_UpdateProgressBar();
  BAB_UpdateSavePrice();
  BAB_UpdateStickyItems();
});
$(document).on('change','select[name=box_selling_plan]',function(){
  const optionSelected = $(this).find('option:selected');
  if(optionSelected.attr('data-interval') == 'month'){
    $('.free-mystery-gift').fadeIn();
  }
  else{
    $('.free-mystery-gift').fadeOut();
  }
});
$(document).on('change','#subscription-toggle',function(){
  if($(this).is(':checked')){
    $('.free-mystery-gift').fadeIn();
  }
  else{
    $('.free-mystery-gift').fadeOut();
  }
})
$(document).on('click','.bab__sticky-checkout-item',function(e){
  const $this = $(this);
  let qtEL = $this.find('input[name=quantity]');
  let qty = parseInt($this.find('input[name=quantity]').val());
  let previousQty = qty;
  let gid = $this.attr('data-gid');
  
  if(e.target.classList.contains('plus')){
       qty += 1;
       qtEL.val(qty);
  }
  if(e.target.classList.contains('minus')){
      if(qty>0){
       qty -= 1;
       qtEL.val(qty);
      }
  }

  $('.product__item.selected[data-gid="'+gid+'"] input[name="quantity"]').val(qty);
  
  // Update cart immediately when quantity changes
  if(qty !== previousQty){
    const productItem = $('.product__item[data-gid="'+gid+'"]');
    // Set loading state for sticky item
    BAB_SetStickyLoadingState($this, true);
    
    // Update cart and handle loading state for main product item
    const id = gid.replace('gid://shopify/ProductVariant/','');
    const selling_plan = $("input[name=box_selling_plan]").val();
    
    if(qty === 0 && previousQty > 0){
      BAB_RemoveFromCart(id, productItem);
    } else if(qty > previousQty){
      const itemData = {
        quantity: 1,
        id: id,
        selling_plan: selling_plan,
        properties: {
          _dynamicBoxIndex: 0,
          _dynamicBoxId: dynamicBoxId
        }
      };
      BAB_AddToCart(itemData, productItem);
    } else if(qty < previousQty && qty > 0){
      BAB_ChangeCartQuantity(id, qty, productItem);
    }
    
    // Remove sticky loading state after a brief delay
    setTimeout(() => {
      BAB_SetStickyLoadingState($this, false);
    }, 500);
  }
  
  BAB_UpdateProgressBar();
  BAB_UpdateSavePrice();
  BAB_UpdateStickyItems();
});

$(document).on('click','.product__nutri-facts', function(){
  const id = $(this).parent().attr('data-gid').replace('gid://shopify/ProductVariant/','');
  const popups =  $('.nutrition__facts-popups .builder-inline-symbol[data-id="'+id+'"]');
  popups.show();
  popups.find('.gm-popup-launch').click();  
});
 
$('.bab__checkout').on('click',function(e){
  e.preventDefault();
  
  $(this).attr('disabled', true);
  $(this).addClass('bab-loading');
  
  // Add loading text
  const originalText = $(this).text();
  $(this).text('Processing...');
  
  // Add free gift if applicable 
  const priceText = $('.bab__price-saved').text();
  const priceNumber = parseFloat(priceText.replace(/[^0-9.-]+/g, ''));

  if(boxParentProductId == 7639865098303 && priceNumber >= 100){
    const freeGiftData = {
      items: [{
        quantity: 1,
        id: $("input[name=fg-color]:checked").val()
      }]
    };
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(freeGiftData)
    })
    .then(response => response.json())
    .then(function (response) {
      window.location.href = '/checkout';
    })
    .catch((error) => {
      console.error('Error adding free gift:', error);
      $(this).removeClass('bab-loading');
      $(this).attr('disabled', false);
      $(this).text(originalText);
      window.location.href = '/checkout';
    });
  } else {
    // No free gift, go directly to checkout
    window.location.href = '/checkout';
  }
});

var handleText1 = $('.handle-txt').html(); 

$(document).on('change','.toggle-switch-check',function() {

  var textHandle = $('.toggle-switch-handle').text();
  
  if(this.checked) {
    $('.form-toggle').removeClass('one-time-enabled');
    $('input[name=box_selling_plan]').val( sellingPlanID );
    
    $('.toggle-switch-handle').hide();
    $('.toggle-switch-handle').fadeIn();

    $('.handle-txt').hide();
    $('.handle-txt').fadeIn();
    $('.handle-txt').html(handleText1); 
    $('.handle-txt-2').fadeIn();
    $('.subscription-benefits').hide();
    
  }
  else{
    $('.form-toggle').addClass('one-time-enabled');
    $('input[name=box_selling_plan]').val( '' );

    $('.toggle-switch-handle').hide();
    $('.toggle-switch-handle').fadeIn();

    $('.handle-txt').hide();
    $('.handle-txt').fadeIn();
    $('.handle-txt').text(`Save an Extra ${sellingPlan.priceAdjustmentAmount}% with Subscription`);


    $('.handle-txt-2').hide();
    $('.subscription-benefits').fadeIn();
  }

  BAB_UpdateSavePrice();
  BAB_UpdateBarDiscount();
});


$(document).on('click','.product__image',function(){
  $('.product__image').removeClass('active');
  $(this).toggleClass('active');
});

$(document).on('click','.product__quickview-close',function(){
  $('.product__image').removeClass('active');
});


function BAB_loadProgressBarFromCart(){
  
  console.log('Loading progress bar from cart');
    let itemCount = 0;
    let CartItems = window.cartItems;
  
    for(let item of CartItems){
      console.log('item', item);
      if(item.properties._dynamicBoxId){
        itemCount+=parseInt(item.quantity);
      }
    }
    console.log('itemCount', itemCount);
  
    $('.bab__progress-bar-wrapper').each(function(){
      console.log('Item Count', itemCount);
      if(itemCount == 1){
        $(this).find('.bab__progress-bar-item').eq(0).addClass('active');
      }
      else if(itemCount == 2){
        $(this).find('.bab__progress-bar-item').eq(0).addClass('completed');
        $(this).find('.bab__progress-bar-item').eq(1).addClass('active');
      }
      else if(itemCount >= 3){
        $(this).find('.bab__progress-bar-item').eq(0).addClass('completed');
        $(this).find('.bab__progress-bar-item').eq(1).addClass('completed');
        $(this).find('.bab__progress-bar-item').eq(2).addClass('active');
      }
    });
    

}

function BAB_LoadQuantityFromCart(){
  let CartItems = window.cartItems;
  for(let item of CartItems){
      if(item.properties._dynamicBoxId){
        $('.product__item[data-gid="gid://shopify/ProductVariant/'+item.variant_id+'"] input[name="quantity"]').val(parseInt(item.quantity));
      }
  }
}